export { default } from "bullitttime-embermodelsevent/models/tie-timing-record";
